/**
 * @param {Phaser.Scene} scene
 * @param {Phaser.Physics.Arcade.Sprite} character
 */
export const createLine = (scene, threshold, character, callback) => {
  let line = scene.add.line(0, threshold + 1, 0xffffff);
  scene.physics.add.existing(line, true);
  scene.physics.add.collider(
    line,
    character,
    () => {
      callback();
    },
    null,
    scene
  );
  return line;
};
